var _a, _b;
export var SignalType;
(function (SignalType) {
    SignalType[SignalType["Topics"] = 1] = "Topics";
    SignalType[SignalType["Keywords"] = 2] = "Keywords";
    SignalType[SignalType["HVC"] = 3] = "HVC";
    SignalType[SignalType["Social"] = 4] = "Social";
    SignalType[SignalType["TechTarget"] = 6] = "TechTarget";
    SignalType[SignalType["Aberdeen"] = 7] = "Aberdeen";
    SignalType[SignalType["SiteVisitor"] = 8] = "SiteVisitor";
    SignalType[SignalType["Display"] = 9] = "Display";
    SignalType[SignalType["Leads"] = 10] = "Leads";
    SignalType[SignalType["Demandbase"] = 11] = "Demandbase";
    SignalType[SignalType["SixthSense"] = 12] = "SixthSense";
    SignalType[SignalType["G2Crowd"] = 13] = "G2Crowd";
    SignalType[SignalType["Dynamic1"] = 14] = "Dynamic1";
    SignalType[SignalType["Stage"] = 17] = "Stage";
    SignalType[SignalType["BusinessEvent"] = 18] = "BusinessEvent";
    SignalType[SignalType["MarketoEngagement"] = 22] = "MarketoEngagement";
    SignalType[SignalType["SalesforceActivity"] = 23] = "SalesforceActivity";
})(SignalType || (SignalType = {}));
export var signalLabels = (_a = {},
    _a[SignalType.Topics] = 'Topics',
    _a[SignalType.Keywords] = 'Keywords',
    _a[SignalType.HVC] = 'HVCs',
    _a[SignalType.Social] = 'Social',
    _a[SignalType.TechTarget] = 'Tech Targets',
    _a[SignalType.Aberdeen] = 'Aberdeen',
    _a[SignalType.SiteVisitor] = 'Site Visitors',
    _a[SignalType.Display] = 'Digital',
    _a[SignalType.Leads] = 'Leads',
    _a[SignalType.Demandbase] = 'Demandbase',
    _a[SignalType.SixthSense] = '6Sense',
    _a[SignalType.G2Crowd] = 'G2Crowd',
    _a[SignalType.Dynamic1] = 'Dynamic1',
    _a[SignalType.Stage] = 'Stage',
    _a[SignalType.BusinessEvent] = 'Business Events',
    _a[SignalType.MarketoEngagement] = 'Marketo Engagement',
    _a[SignalType.SalesforceActivity] = 'Salesforce Activity',
    _a);
export var signalLabelsSingular = (_b = {},
    _b[SignalType.Topics] = 'Topic',
    _b[SignalType.Keywords] = 'Keyword',
    _b[SignalType.HVC] = 'HVC',
    _b[SignalType.Social] = 'Social',
    _b[SignalType.TechTarget] = 'Tech Target',
    _b[SignalType.Aberdeen] = 'Aberdeen',
    _b[SignalType.SiteVisitor] = 'Site Visitor',
    _b[SignalType.Display] = 'Digital',
    _b[SignalType.Leads] = 'Lead',
    _b[SignalType.Demandbase] = 'Demandbase',
    _b[SignalType.SixthSense] = '6Sense',
    _b[SignalType.G2Crowd] = 'G2Crowd',
    _b[SignalType.Dynamic1] = 'Dynamic1',
    _b[SignalType.Stage] = 'Stage',
    _b[SignalType.BusinessEvent] = 'Business Event',
    _b[SignalType.MarketoEngagement] = 'Marketo Engagement',
    _b[SignalType.SalesforceActivity] = 'Salesforce Activity',
    _b);
//# sourceMappingURL=Signal.js.map